import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalVar } from '../globals/global-var';
import { Member } from '../models/member';
import { Permission } from '../models/permission';
import { Banner } from '../models/banner';

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  constructor(private http: HttpClient, private globalVar: GlobalVar) { }

  getMemberListApi(keyword: string): Observable<Member[]> {
    return this.http.get<Member[]>(this.globalVar.targetIp + '/api/member', { params: { keyword: keyword } });
  }

  postMemberApi(member: Member): Observable<any> {
    return this.http.post<any>(this.globalVar.targetIp  + '/api/member', member);
  }

  getMemberApi(id: string): Observable<Member> {
    return this.http.get<Member>(this.globalVar.targetIp  + '/api/member/' + id);
  }

  getPermissionListApi(id: string): Observable<Permission[]> {
    return this.http.get<Permission[]>(this.globalVar.targetIp + '/api/member/' + id + '/PermissionList');
  }

  putMemberApi(id: string, member: Member): Observable<any> {
    return this.http.put<any>(this.globalVar.targetIp  + '/api/member/' + id, member);
  }

  deleteMemberApi(id: string): Observable<any> {
    return this.http.delete<any>(this.globalVar.targetIp  + '/api/member/' + id);
  }


  postBannerApi(bannerList: Banner[]): Observable<any> {
    return this.http.post<any>(this.globalVar.targetIp + '/api/member/Banners', bannerList);
  }

  getBannerApi(): Observable<Banner[]> {
    return this.http.get<Banner[]>(this.globalVar.targetIp + '/api/member/Banners');
  }
}
